import {
  any, boolean, date, nullable,
  object, string,
} from '@sda/sdk/helpers/types.bitmasks';

export const PublicThreadMask = {
  actId: string | nullable,
  beaconId: string | nullable,
  matchId: string | nullable,
  showId: string | nullable,
  connectionId: string | nullable,
  venueId: string | nullable,
  isMasterThread: boolean,
  usesNewConnect: boolean,
  hasConnection: boolean,
  connectedAt: date | nullable,
  connectionProfileId: string | nullable,
  connectionProfileType: string | nullable,
  profileSubscribers: any,

  hasDateApproval: boolean,
  hasDateApprovalMeta: object,

  hasTicketApproval: boolean,
  hasTicketApprovalMeta: object,

  hasOtherApproval: boolean,
  hasOtherApprovalMeta: object,

  hasPromoApproval: boolean,
  hasPromoApprovalMeta: object,

  hasPlatformApproval: boolean,
  hasPlatformApprovalMeta: object,

  hasSignApproval: boolean,
  hasSignApprovalMeta: object,

  publicAct: object | nullable,
  publicBeacon: object | nullable,
  publicVenue: object | nullable,
  publicShow: object | nullable,

  collaborators: any,
  createdAt: date,
  owner: string,
  updatedAt: date,

  // Profile updates
  profileIds: any,
  publicProfiles: any,
  profileHash: string,
};
